
    <nav>
      <div class="hamburger" *ngIf="service?.active" (click)="hamburgerClick.emit()">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="container" [class.active]="service?.active">
        <girko-logo></girko-logo>
        <a *ngIf="service" class="back-link" (click)="goToProfile.emit(service)">
          {{'Мій профіль' | translate}} &rarr;
        </a>
      </div>
    </nav>
  